import baseTheme from '@bottlebooks/gatsby-theme-event/src/theme';
import merge from 'lodash/merge';
import { darken } from 'polished';

const theme = {
  ...baseTheme,
  fontUrls: [
    'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600&family=Roboto&display=swap',
  ],

  fonts: merge({}, baseTheme.fonts, {
    heading: 'Montserrat, sans-serif',
    body: 'Roboto, sans-serif',
  }),
  fontWeights: {
    ...baseTheme.fontWeights,
    heading: '600',
    body: '400',
  },
  title: merge({}, baseTheme.title, {
    _base: {
      WebkitFontSmoothing: 'antialiased',
    }, // Add antialiasing to titles.
  }),
  colors: merge({}, baseTheme.colors, {
    ...baseTheme.colors,
    primary: 'black',
    secondary: darken(0.1)('#5c7c95'),
    accent: '#5c7c95',
  }),
  styles: {
    ...baseTheme.styles,
    root: {
      ...baseTheme.styles.root,
      WebkitFontSmoothing: 'subpixel-antialiased',
    },
  },
};

// console.log(theme);
export default theme;
